<template>
  <div class="PreviewfileFormat">
    <ModelDetail
      v-if="fileType.toLowerCase() === 'mim'"
      @handleModel="changeModel"
      @allName="getAllNames"
      @selectedName="checkObj"
      :rowId="rowId"
      :fileId="fileId"
      :jumpSource="jumpSource"
      :queryInfo="queryInfo"
      ref="mychild"
    />
    <!-- 头部导航 -->
    <div v-show="this.jumpSource != 'model'" class="headerBtn">
      <div class="fl">
        <div class="mBtn">
          <!-- <el-button size="mini" id="modelList" @click="toMList"
            >返回模型列表</el-button
          > -->
          <span class="file_name">{{ file_name }}</span>
          <!--          <span class="file_name" @click="openOverview">视角</span>-->
        </div>
      </div>
      <div class="fr">
        <!-- <el-button
          class="el-icon-share"
          size="mini"
          @click="shareDialog = true"
          style="margin-right: 10px"
        ></el-button> -->
        <span id="tabBtn" v-if="jumpSource == 'document'">
          <el-button
            class="el-icon-edit"
            size="mini"
            @click="annotation"
          ></el-button>
        </span>
      </div>
    </div>
    <div
      id="domId"
      :class="fileType.toLowerCase() === 'mim' ? 'hide_old' : ''"
    ></div>
    <!--模型图纸批注-->
    <div class="document-comments" v-if="commentsAlert">
      <comments
        :commentsData="{
          rowId: rowId,
          viewer2D: viewer2D,
          modelViewer: modelViewer,
        }"
        @colseCommentsList="colseCommentsList"
      ></comments>
    </div>
    <!-- 分享链接的对话框 -->
    <el-dialog
      :title="$t('share_model_links')"
      :visible.sync="shareDialog"
      class="shareDialog"
    >
      <el-form :model="shareForm">
        <el-form-item style="margin-left: 10%">
          <i class="el-icon-circle-check"></i>
          <span>{{ $t("omodel_link_createdk") }}</span>
        </el-form-item>
        <el-form-item :label="$t('model_link')" :label-width="formLabelWidth">
          <el-input
            v-model="shareForm.name"
            autocomplete="off"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button type="primary" style="margin-right: 10px" @click="copy">{{
            $t("copy_link")
          }}</el-button>
          <!-- <el-button @click="seeLinks">查看链接</el-button> -->
          <a
            @click="shareDialog = false"
            href="https://api.bimface.com/preview/d5d23309"
            class="el-button el-button--default"
            target="_blank"
            >{{ $t("view_link") }}</a
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button>{{ $t("cancel_sharing") }}</el-button>
        <el-button @click="shareDialog = false">{{ $t("close") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import api from "@/url/api.js";
import ModelDetail from "../components/documentManagement/modelDetail.vue";
import documentUrl from "@/url/document";
import comments from "@/components/documentManagement/assembly/comments";
export default {
  props: ["modelData"],
  components: { ModelDetail, comments },
  data() {
    return {
      fileId: "",
      viewToken: "",
      rowId: "",
      viewer2D: null,
      model3D: null,
      WebAppConfig: null,
      displayrectangle: false,
      shareDialog: false,
      formLabelWidth: "140px",
      file_name: "", //
      shareForm: {
        name: "https://api.bimface.com/preview/d5d23309",
      },
      isIntegratedModel: false,
      ObjectByChild: null, //子组件传来的id
      lastObject: null,
      allNames: null,
      selectedNames: null,
      fileType: null, //
      // updateObject:null,
      jumpSource: "",
      modelViewer: {},
      commentsAlert: false,
    };
  },
  created() {
    //集成模型
    if (this.$route.query.type == 1) {
      this.isIntegratedModel = true;
    }
    this.fileType = this.$route.query.file_type;
    this.jumpSource = this.$route.query.source;
    this.queryInfo = this.$route.query;
    //因为有modelDetail组件 将mounted代码移入created
    if (this.modelData) {
      this.fileId = this.modelData.fileId;
      this.file_name = this.modelData.file_name;
      this.fileType = this.modelData.file_type;
      // this.rowId=this.modelData.fileId;
    } else {
      this.fileId = this.$route.query.fileId;
      this.file_name = this.$route.query.file_name;
      this.rowId = this.$route.query.rowId;
    }
  },
  mounted() {},
  methods: {
    //获取view_token
    get_view_token() {
      const url = api.get_bimface_view_token.url;
      const _url = api.integrate_get_integrate_viewToken.url;

      var fileIds = {
        fileId: this.fileId,
      };

      if (this.isIntegratedModel) {
        //集成模型获取token
        axios.post(_url, { integrateId: this.fileId }).then((resp) => {
          if (resp.data.code == 200) {
            this.viewToken = resp.data.msg;
          } else {
            this.$message.error("获取token失败");
          }
        });
      } else {
        //单体模型获取token
        axios.post(url, fileIds).then((resp) => {
          if (resp.data.status == "success") {
            this.viewToken = resp.data.info;
          } else {
            this.$message({
              type: "error",
              message: "获取模型token失败(请查看模型是否转换成功)",
            });
          }
        });
      }
    },
    getBim() {
      var _that = this;
      var dwgViewer = {
        toolbar: undefined, // 工具条
        annotationmanager: undefined, // annotation的绘制管理器
        annotationToolbar: undefined,
        annotationControl: undefined, // 重写annotation的保存、取消
      };
      var options = new BimfaceSDKLoaderConfig();
      options.viewToken = this.viewToken;
      BimfaceSDKLoader.load(
        options,
        (viewMetaData) => {
          if (viewMetaData.viewType == "drawingView") {
            // 判断是否为矢量图纸
            // 获取DOM元素
            var dom4Show = document.getElementById("domId");
            var WebAppConfig =
              new Glodon.Bimface.Application.WebApplicationDrawingConfig();
            WebAppConfig.domElement = dom4Show;
            WebAppConfig.viewToken = viewMetaData.viewToken;
            //创建WebApplication
            _that.app = new Glodon.Bimface.Application.WebApplicationDrawing(
              WebAppConfig
            );
            //添加待显示的模型
            _that.app.load(options.viewToken);
            _that.viewer2D = _that.app.getViewer();

            //监听添加view完成的事件
            drawingViewExtend(_that.viewer2D, _that.app, _that.customComments);
          } else {
            // 获取DOM元素
            var dom4Show = document.getElementById("domId");
            this.WebAppConfig =
              new Glodon.Bimface.Application.WebApplication3DConfig();
            this.WebAppConfig.domElement = dom4Show;
            this.resetTool();
            // 创建WebApplication
            _that.app = new Glodon.Bimface.Application.WebApplication3D(
              this.WebAppConfig
            );
            // 添加待显示的模型
            _that.app.addView(options.viewToken);

            // 从WebApplication获取viewer3D对象
            _that.viewer2D = _that.app.getViewer();
            //标签类的设置
            var drawableConfig =
              new Glodon.Bimface.Plugins.Drawable.DrawableContainerConfig();
            drawableConfig.viewer = this.viewer2D;
            //容器
            this.drawableContainer =
              new Glodon.Bimface.Plugins.Drawable.DrawableContainer(
                drawableConfig
              );
            // 监听添加view完成的事件
            _that.viewer2D.addEventListener(
              Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded,
              () => {
                //自适应屏幕大小
                window.onresize = function () {
                  _that.viewer2D.resize(
                    document.documentElement.clientWidth,
                    document.documentElement.clientHeight - 40
                  );
                };
                this.updateToolMsg(this.app);
                // 从viewer3D对象中获取模型对象model3D
                this.model3D = _that.viewer2D.getModel();
                // console.log('3d');
                _that.customComments(_that.app);
              }
            );
            //点击获取构件
            _that.viewer2D.addEventListener(
              Glodon.Bimface.Viewer.Viewer3DEvent.ComponentsSelectionChanged,
              (componentData) => {
                if (componentData && componentData.objectId) {
                  // console.log("获得构件id的地方");
                  // console.log(componentData.objectId);
                  this.ObjectByChild = componentData.objectId;
                  this.handleObjectColor();
                }
              }
            );
          }
        },
        failureCallback
      );
      function failureCallback(error) {
        console.log(error);
      }
      //矢量dwg扩展功能
      function drawingViewExtend(viewer2D, app, fn) {
        var viewerEvents = Glodon.Bimface.Viewer.ViewerDrawingEvent;
        viewer2D.addEventListener(viewerEvents.Loaded, function () {
          //自适应屏幕大小
          window.onresize = function () {
            viewer2D.resize(
              document.documentElement.clientWidth,
              document.documentElement.clientHeight - 40
            );
          };
          document.getElementsByClassName("bf-toolbar-search")[0].style.top =
            "50px";
          // 添加批注按钮
          var viewerDom = viewer2D.getDomElement();
          dwgViewer.toolbar = $(viewerDom).find(".bf-toolbar-bottom");
          fn(app);
        });
      }
    },
    //点击bimface, objectId着色
    handleObjectColor() {
      this.addRemoveColor();
      console.log("点击的构件id为", this.ObjectByChild);
      this.$refs.mychild.parentHandleclick(this.ObjectByChild);
    },
    addRemoveColor() {
      // let color = new Glodon.Web.Graphics.Color("#11dab7", 0.8);
      if (this.lastObject !== this.ObjectByChild) {
        //点击不同一个 着色,给上个去色
        // console.log("着色", this.lastObject, this.ObjectByChild);
        this.viewer2D.getModel().clearSelectedComponents();
        if (Array.isArray(this.ObjectByChild)) {
          this.viewer2D
            .getModel()
            .setSelectedComponentsById(this.ObjectByChild);
        } else {
          this.viewer2D
            .getModel()
            .setSelectedComponentsById([this.ObjectByChild]);
        }
        this.viewer2D.getModel().zoomToSelectedComponents();
      }
      this.lastObject = this.ObjectByChild;
    },
    //点击tree, modelDetail页面传来的id着色
    changeModel(id) {
      this.ObjectByChild = id;
      // console.log(id)
      this.addRemoveColor();
    },
    //拿到子组件传来的所有Names 也就是构件id
    getAllNames(allNames) {
      this.allNames = allNames;
    },
    //点击tree的checkbox, modelDetail页面传来的构件取消或隐藏
    checkObj(selectedNames) {
      this.selectedNames = selectedNames;
      // console.log('selectedNames',this.selectedNames)
      this.model3D.hideComponentsById(this.allNames);
      this.model3D.showComponentsById(this.selectedNames);
      this.viewer2D.render();
    },
    toMList() {
      this.$router.push("/fileControl");
    },
    copy() {
      var copyInner = this.shareForm.name;
      var oInput = document.createElement("input");
      oInput.value = copyInner;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.style.display = "none";
      this.$message({
        type: "success",
        message: "复制成功",
      });
    },
    //自定义批注按钮
    customComments(app) {
      if (this.jumpSource != "document") {
        return;
      }
      var _this = this;
      var toolbar = app.getToolbar("MainToolbar");
      var btnConfig = new Glodon.Bimface.UI.Button.ButtonConfig();
      var btn = new Glodon.Bimface.UI.Button.Button(btnConfig);
      btn.element.title = "批注";
      btn.setHtml(
        `<svg viewBox="0 0 1170 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path d="M18.285714 0h1024v1024H18.285714z" fill="rgba(17,17,17,0.88)"></path><path d="M251.885714 678.4l192 108.8L658.285714 409.6l-192-108.8-214.4 377.6zM229.485714 736l32 144L402.285714 832l-172.8-96z m272-492.8l192 108.8 51.2-96-192-108.8-51.2 96zM159.085714 713.6L530.285714 64l297.6 172.8L456.685714 883.2 213.485714 960 159.085714 713.6zM530.285714 960v-64h435.2v64H530.285714z" fill="#fff"></path></svg>`
      );
      toolbar.insertControl(8, btn);
      btn.addEventListener("click", () => {
        _this.createAnnotation(_this.viewer2D);
      });
    },
    //创建批注
    createAnnotation(viewer) {
      let _this = this;
      $("#domId").find(".bf-toolbar-bottom").hide();
      if (!this.modelViewer.annotationmanager) {
        var config =
          new Glodon.Bimface.Plugins.Annotation.AnnotationToolbarConfig();
        config.viewer = viewer;
        var annotationToolbar =
          new Glodon.Bimface.Plugins.Annotation.AnnotationToolbar(config);
        this.modelViewer.annotationToolbar = annotationToolbar;
        this.modelViewer.annotationmanager =
          annotationToolbar.getAnnotationManager();
      }
      var control = $(
        this.modelViewer.annotationToolbar.domElement.lastElementChild
      );
      var html = control[0].innerHTML;
      if ($(".bf-toolbar-control").find("input").length < 1) {
        html =
          '<div class="bf-toolbar bf-toolbar-control">' +
          '<input class="txtInput" style="height: 30px;" placeholder="请输入" maxlength="30">' +
          html +
          "</div>";
      } else {
        html = '<div class="bf-toolbar bf-toolbar-control">' + html + "</div>";
      }
      this.modelViewer.annotationControl = $(html);
      this.modelViewer.annotationControl.insertAfter(control);
      $("#domId .bf-annotation").width("890px");
      control.remove();
      this.modelViewer.annotationControl
        .find(".bf-save")
        .off("click")
        .on("click", function () {
          _this.saveAnnotation();
        });
      this.modelViewer.annotationControl
        .find(".bf-cancel")
        .off("click")
        .on("click", function () {
          _this.canelAnnotation();
        });
      this.modelViewer.annotationToolbar.show();
    },

    //保存批注
    saveAnnotation() {
      let _this = this;
      //检查是否有批注
      if (!this.modelViewer.annotationmanager.getAnnotationList().length) {
        alert("批注不能为空");
        return false;
      }
      //检查是否有说明
      var textInput = $.trim(
        this.modelViewer.annotationControl.find("input").val()
      );
      if (!textInput) {
        alert("批注描述不能为空");
        return false;
      }
      let _state = this.modelViewer.annotationmanager.getCurrentState();
      if (_state.annotationList.length == 0) {
        const emptyObj = {
          rotation: 0,
          markupType: "Cross",
          drawPoints: [0, 0],
          strokeStyle: "rgba(0,0,0,0)",
          lineWidth: 0,
          bNeedHitByBbox: false,
          drawEnd: true,
          markupId: "",
        };
        _state.annotationList.push(emptyObj);
      }
      // 批注导出快照
      this.modelViewer.annotationmanager.createSnapshot(function (img) {
        _this.getSaveAnnotation(img, textInput, _state);
        _this.viewer2D.render();
      });
      _this.canelAnnotation();
    },
    //取消批注
    canelAnnotation() {
      this.modelViewer.annotationControl.find("input").val("");
      // 卸载批注
      this.modelViewer.annotationmanager.endDrawing &&
        this.modelViewer.annotationmanager.endDrawing();
      $(this.modelViewer.annotationToolbar.domElement).addClass("bf-hide");
      $("#domId").find(".bf-toolbar-bottom").show();
    },
    //打开批注列表
    annotation() {
      this.rowId = this.$route.query.rowId;
      this.commentsAlert = true;
    },
    //提交模型批注保存
    getSaveAnnotation(img, textInput, _state) {
      let _url = documentUrl.document_comments;
      let _id = this.$route.query.rowId;
      let _data = {
        file_id: _id,
        description: textInput,
        status: JSON.stringify(_state),
        img: img,
      };
      axios.post(_url, _data).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.commentsAlert = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //关闭批注列表
    colseCommentsList(state) {
      this.commentsAlert = false;
    },
    openOverview() {
      let homeview = this.viewer2D.getCameraStatus();
      console.log(JSON.stringify(homeview));
      console.log(JSON.stringify(this.model3D.getCameraStatus()));
    },
  },
  watch: {
    fileId(newval) {
      this.get_view_token();
    },
    viewToken(newval) {
      this.getBim();
    },
  },
  beforeDestroy() {
    this.app.destroy();
  },
};
</script>
<style scoped>
.PreviewfileFormat {
  width: 100%;
  height: 100%;
  position: relative;
}
#domId {
  width: 100%;
  height: calc(100% - 50px);
  transition: all 0.3s ease-in-out; /*批注的动画*/
}
#domId >>> .location {
  margin-right: 10px;
  margin-top: 5px;
}
.headerBtn {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  background: rgb(63, 149, 196);
  z-index: 99;
  position: relative;
}
.headerBtn >>> .el-button--mini,
.el-button--small {
  font-size: 14px;
}
.gray {
  color: #606266;
}
.vName {
  margin-left: 0px;
}
.vName,
.vVersion {
  color: #efe;
}
.vName {
  margin-left: 130px;
}

.vVersion {
  margin-left: 10px;
}
.versionList {
  width: 400px;
  box-shadow: 0 1px 1px #ccc;
  padding: 0 10px 25px;
  position: fixed;
  z-index: 999;
  background: #fff;
}
.versionList ul li {
  width: 100%;
  height: 70px;
  border-bottom: 1px solid #ccc;
}

.versionList ul li div:first-child {
  margin-right: 30px;
}
.versionList ul li div:last-child {
  width: 85%;
}
.versionList ul li div:last-child p {
  height: 30px;
  line-height: 44px;
  width: 100%;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.versionList ul li div:last-child p span:last-child {
  position: absolute;
  right: 10px;
}
span#toggle:hover {
  cursor: pointer;
}
.vList {
  height: 25px;
  line-height: 25px;
  position: absolute;
  right: 10px;
  bottom: 0;
  font-size: 12px;
}
.vList:hover {
  cursor: pointer;
}
.triangle {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px;
  border-color: #3f95c4 #fff #fff #fff;
  position: absolute;
  top: 0px;
  left: 10%;
}
.el-icon-arrow-down {
  color: #ccc;
}
.mBtn {
  position: absolute;
  /* left: 11.5%; */
  margin-left: 0px;
}
.file_name {
  padding: 0 10px;
  color: #fff;
}

#domId >>> .bf-tree-toolbar {
  /* display: none; */
}

#domId >>> .bf-panel {
  /* display: none; */
}

.hide_old >>> .gld-bf-properties {
  display: none;
}

.hide_old >>> .bf-menu-right > .bf-menu-item:nth-child(1) {
  display: none;
}

.hide_old >>> .gld-bf-tree {
  display: none;
}
.document-comments {
  width: 338px;
  height: calc(100% - 51px);
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewfileFormat.vue